import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "right-arrow",
  "use": "right-arrow-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" id=\"right-arrow\">\n    <path d=\"M15.182 11.4348L8.89432 5.14708C8.68616 4.94604 8.35446 4.95182 8.15342 5.15997C7.9573 5.36304 7.9573 5.68494 8.15342 5.88797L14.0707 11.8052L8.15342 17.7225C7.94886 17.9271 7.94886 18.2588 8.15342 18.4634C8.35805 18.668 8.68972 18.668 8.89432 18.4634L15.182 12.1757C15.3866 11.9711 15.3866 11.6394 15.182 11.4348Z\" fill=\"white\" stroke=\"white\" stroke-width=\"1.5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol